import { Container } from 'react-bootstrap'
import styled from 'styled-components'

const ContentContainer = styled(Container)`
  max-width: 100%;
  padding: 0;
`

export { ContentContainer }
